const KNOWN_SEARCH_MODES = new Set(["basic", "pro"]);
const INTERNAL_HISTORY_SEARCH_TYPES = new Set([
  "WEBSOCKET_V2",
  "HTTP_V2",
  "FOLLOWUP_V2",
  "WEBSOCKET",
  "HTTP",
]);

export const normalizeHistorySearchMode = (searchMode) => {
  const normalized = String(searchMode || "").trim().toLowerCase();
  return KNOWN_SEARCH_MODES.has(normalized) ? normalized : "";
};

export const isBasicSearchMode = (searchMode) =>
  normalizeHistorySearchMode(searchMode) === "basic";

export const getHistorySearchModeLabel = ({ searchMode, t }) => {
  const normalized = normalizeHistorySearchMode(searchMode);
  if (!normalized) {
    return "";
  }
  return normalized === "basic"
    ? t("app.searchModes.basic")
    : t("app.searchModes.pro");
};

const normalizeMeaningfulSearchType = (searchType) => {
  const normalized = String(searchType || "").trim();
  if (!normalized) {
    return "";
  }
  return INTERNAL_HISTORY_SEARCH_TYPES.has(normalized.toUpperCase())
    ? ""
    : normalized;
};

export const shouldShowHistorySearchType = (search) =>
  !isBasicSearchMode(search?.search_mode) &&
  Boolean(
    String(search?.preference || "").trim() ||
      normalizeMeaningfulSearchType(search?.search_type),
  );

export const getHistorySearchTypeLabel = ({ search, t }) => {
  const preference = String(search?.preference || "").trim();
  if (preference) {
    const translated = t(`searchHistory.preferences.${preference}`);
    return translated && translated !== `searchHistory.preferences.${preference}`
      ? translated
      : preference;
  }
  return normalizeMeaningfulSearchType(search?.search_type);
};

export const getHistoryCreditsLabel = ({ chargedCredits, t }) => {
  const count = Number(chargedCredits);
  if (!Number.isFinite(count) || count < 1) {
    return "";
  }
  if (count === 1) {
    return t("searchHistory.creditSingular", { count });
  }
  return t("searchHistory.creditPlural", { count });
};
